import { SelectOption } from '@anm/components/select/Select';
import { onDateChangeProps } from '@anm/components/stream/types';
import createArray from '@anm/helpers/array/createArray';
// import round2Chars from '@anm/helpers/parsers/round2Chars';
import { useCallback, useEffect, useState } from 'react';

export const AM = 'AM';
export const PM = 'PM';
export const MINS_STEP = 5;

const useStreamTime = (date: number, onDateChange: (p: onDateChangeProps) => void) => {
  const [timeType, setTimeType] = useState<typeof PM | typeof AM>(PM);

  const hoursOptions = createArray(12, 1).map(n => ({ label: `${n}`, value: n }));
  const minsOptions = createArray(12, 0, MINS_STEP).map(n => ({ label: `${n}`, value: n }));
  const timeTypeOptions = [
    { value: AM, label: AM },
    { value: PM, label: PM }
  ];

  // const roundedMins = m % MINS_STEP === 0 ? m : m + MINS_STEP - (m % MINS_STEP);
  // const defaultMin = roundedMins === 60 ? 0 : roundedMins;
  const mins = new Date(date).getMinutes();
  const hours = new Date(date).getHours();
  const h = hours || 12;

  const timeTypeValue = { value: timeType, label: timeType };
  const minsValue = { value: mins, label: `${mins}` };
  const hoursValue = { value: h, label: `${h > 12 ? h - 12 : h}` };

  useEffect(() => {
    const d = new Date(date);
    const oldDate = d.getDate();

    const hh = d.getHours();
    d.setMinutes(mins);
    d.setSeconds(0);
    const newDate = d.setDate(oldDate);

    const isAm = hh <= 11;
    const newType = isAm ? AM : PM;

    timeType !== newType && setTimeType(newType);
    onDateChange({ dates: [newDate] });
  }, []);

  const onTimeTypeChange = useCallback(
    ({ value }: SelectOption) => {
      if (timeType === value) return;

      const d = new Date(date);

      const oldDate = d.getDate();
      const h = d.getHours();
      const newHours = h === 0 && value === AM ? h : h - (timeType === PM ? 12 : -12);

      d.setHours(newHours);
      d.setDate(oldDate);

      setTimeType(value);
      onDateChange({ dates: [d.getTime()] });
    },
    [date, timeType]
  );

  const handleMinsChange = useCallback(
    ({ value }: SelectOption) => {
      const d = new Date(date);
      const oldDate = d.getDate();
      d.setMinutes(value);
      d.setDate(oldDate);

      onDateChange({ dates: [d.getTime()] });
    },
    [date]
  );

  const handleHoursChange = useCallback(
    ({ value }: SelectOption) => {
      const d = new Date(date);

      const newHours = timeType === AM ? (value === 12 ? 0 : value) : value === 12 ? value : value + 12;
      const oldDate = d.getDate();

      d.setHours(newHours);
      d.setDate(oldDate);

      onDateChange({ dates: [d.getTime()] });
    },
    [date, timeType]
  );

  return {
    minsValue,
    hoursValue,
    minsOptions,
    hoursOptions,
    timeTypeValue,
    timeTypeOptions,
    onTimeTypeChange,
    handleMinsChange,
    handleHoursChange
  };
};

export default useStreamTime;
